export default interface SerCar {
    id: number;
    regNum: string;
    salePrice: number;
    bodyNo: number;
}

export const serCarDefaultProps: SerCar = {
    id: 0,   
    regNum: "",
    salePrice: 0,
    bodyNo: 0,
}